import { analytics } from "./analytics";
import { attachment } from "./attachment";
import { auth } from "./auth";
import { invitation } from "./invitation";
import { map } from "./map";
import { permission } from "./permission";
import { project } from "./project";
import { survey } from "./survey";
import { team } from "./team";
import { user } from "./user";
import { version } from "./version";
import { workspace } from "./workspace";

export const endpoints = {
  analytics,
  attachment,
  auth,
  invitation,
  map,
  permission,
  survey,
  project,
  team,
  user,
  workspace,
  version,
};

export { AttachmentSearchOptions } from "./attachment";
export {
  InvitationSearchOptionsV1,
  InvitationSearchOptionsV2,
  InvitationSortKey,
} from "./invitation";
export { FeatureSearchParamsV1, FeatureSearchParamsV2 } from "./map";
export { SortDir, SortOrder } from "./params";
export { ProjectSearchOptions, ProjectSortKey } from "./project";
export {
  SurveySearchKey,
  SurveySearchOptionsV2,
  SurveySearchOptionsV3,
} from "./survey";
export { TeamSearchOptions, TeamSortKey } from "./team";
export { UserSearchOptionsV1, UserSearchOptionsV2, UserSortKey } from "./user";
export { WorkspaceSearchOptions, WorkspaceSortKey } from "./workspace";
